export default __webpack_public_path__ + "static/media/icon-ev.33892645.svg";